/* eslint-disable */
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import Quiz from '../../components/Quiz';
import HighlightedCardsGrid from '../../components/HighlightedCardsGrid';
import bestPracticeImg from '../../../../../../assets/student-training/pyde/img7.png';
import quizIllustration from '../../../../../../assets/student-training/component/quiz-bg.png';
import { EMAIL_RISK_ICONS } from './iconMap';

interface ISection2Props {
  settings: any;
}

const Section3: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const param = useParams();
  const ID = '4';
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(() => settings?.paragraphs[3], [settings]);
  const updateComponentState = useUpdateComponentState();

  const quiz = paragraphsSettings?.quiz;

  const EMAIL_RISK_ITEMS =
    paragraphsSettings?.items?.map((item: any, index: number) => ({
      title: item.title,
      content: item.content,
      icon: EMAIL_RISK_ICONS[index](false),
    })) ?? [];

  return (
    <div className="topic-section-3">
      <HighlightedCardsGrid
        mainTitle={paragraphsSettings?.title}
        subTitle={paragraphsSettings?.subTitle}
        description={paragraphsSettings?.description}
        items={EMAIL_RISK_ITEMS}
      />

      {/* <HighlightedCardsGrid
        mainTitle="可疑訊息及連結的常見特徵"
        description="可疑訊息及連結未必一眼便能分辨，但當中往往會出現一些值得提高警覺的跡象。"
        items={SUSPICIOUS_MSG_ITEMS}
      /> */}
      {/* <RealCaseContent
        backgroundImage={caseTopBg}
        headingLines={paragraphsSettings.exampleHeading}
        descTitle={paragraphsSettings.descTitle}
        overviewList={paragraphsSettings.overviewList}
        dataSource={paragraphsSettings.dataSource}
        dataSourceList={paragraphsSettings.dataSourceList}
      />
      <CaseTabsContent item={paragraphsSettings?.case} /> */}
      <div className="email-best-practice">
        <div className="ebp-illustration">
          <img src={bestPracticeImg} alt="" />
        </div>
        <div className="ebp-content">
          <h2 className="ebp-title">{paragraphsSettings.section2Title}</h2>
          <p className="ebp-description">
            {paragraphsSettings.section2Description}
          </p>
          <div className="ebp-list">
            {paragraphsSettings.section2Items?.map((item: string, index: number) => (
              <div key={index} className="ebp-item highlighted">
                <div className="ebp-item-number">
                  <span>{index + 1}</span>
                </div>
                <div className="ebp-item-text">{item}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div id="student-training-pyde-section3-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          quizImg={quizIllustration}
          onCompleted={() => {
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'student-training-pyde-section3-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section3;
